<template>
<div>
  <div class="row"><br></div>
  <div class="row">
    <div class="col-sm">
      <GmapMap
        ref="mmm"
        :center="center"
        :zoom="zoom"
        :options="optionsMap"
        @click="clickMapa"
        map-type-id="roadmap"
        style="height: 400px"
      >
        <GmapMarker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="false"
          @click="centrar(m.position)"
        />
      </GmapMap>

    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <form class="form-inline">
        <div class="form-group">
          <label for="autocompletado">Autocompletar:</label>
          <gmap-autocomplete
            class="form-control mx-sm-3"
            id="autocompletado"
            @place_changed="setPlace">
          </gmap-autocomplete>
          <button type="button" class="btn btn-primary" @click.prevent="usePlace">Añadir</button>
        </div>
      </form>
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <div class="form-group">
        <label for="direccion">Dirección</label>
        <input type="text" class="form-control" id="direccion" v-model="direccion" placeholder="dirección">
      </div>
      <button type="button" class="btn btn-primary" @click="getGeocode">Consultar1</button>
      <button type="button" class="btn btn-primary" @click="getGeocode2">Consultar2</button>
      <button type="button" class="btn btn-secondary" @click="direccion=''">limpiar</button>
      <!-- <input type="number" class="form-control" id="zoom" v-model.number="zoom"> -->
      
    </div>
  </div>

  <div class="row">
    <div class="col-sm">
      <div v-for="(item, index) in markers" :key="index">
        <p>
          <a href="/" @click.prevent="centrar(item.position)">{{item.title}}</a> 
          <button type="button" class="btn btn-danger btn-sm" @click="markers.splice(index,1)">Eliminar</button>
          <!-- <button type="button" class="btn btn-default btn-sm" @click="getRoute(item.position)">Ruta1</button> -->
          <button type="button" class="btn btn-primary btn-sm" @click="getRoute2(item.position)">Ruta2</button>
        </p>
      </div>
      <p class="font-weight-bold">Distancia ruta: {{distancia_ruta}}</p>
      <div v-for="(item, index) in rutas" :key="item.summary">
        <p>
          <a href="/" @click.prevent="showRoute(item)">ruta-{{index}}</a> 
        </p>
      </div>
      <pre>
        <!-- {{$data}} -->
      </pre>
    </div>
    
    <div id="directions_panel" class="col-sm">
      
    </div>
  </div>
</div>
</template>

<script>
// import store from 'store/simplestore';
import Vue from 'vue'
import axios from 'axios'
import * as VueGoogleMaps from 'vue2-google-maps'
// import {gmapApi} from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAal7_QwpdkdUQoIbxwPwyKNH2h6MMC1wk',
    libraries: 'visualization,places'
  }
});

export default {
  name: 'geocode',
  data() {
    return {
      url: '',
      direccion: 'c. La Rabasa, 2. 38009. Tenerife. ES',
      distancia_ruta: '',
      coordenadas: null,
      central: {
        "title": "Central",
        "formatted_address": "Calle la Rabasa, 2, 38009 Santa Cruz de Tenerife, España",
        "position": {
          "lat": 28.4510749,
          "lng": -16.273595
        }
      },
      markers: [
        {
          "title": "Avda. El Paso, 25",
          "formatted_address": "Av. el Paso, 25, 38108 San Cristóbal de La Laguna, Santa Cruz de Tenerife, España",
          "position": {"lat":28.45943729999999,"lng":-16.301311700000042}
        },
        {
          "title": "Diario de Avisos",
          "formatted_address": "Calle de Salamanca, 5, 38006 Santa Cruz de Tenerife, España",
          "position": {"lat":28.4675229,"lng":-16.263661100000036}
        },
        {
          "title": "Lidl, Los Majuelos",
          "formatted_address": "Calle Ntra. Sra. de la Ternura, s/n, 38108 San Cristóbal de La Laguna, Santa Cruz de Tenerife, España",
          "position": {
            "lat": 28.4572186,
            "lng": -16.3033198
          }
        }        
      ],
      viewport: {},
      mapName: 'sepet-map',
      optionsMap: {
        // scrollwheel: false,
        // disableDefaultUI: true
        // zoomControl: false,
        streetViewControl: false,
        mapTypeControl: false
      },
      myPosition: {},
      center: {
          "lat": 28.4874009,
          "lng": -16.3159061
      },
      zoom: 16,
      result: null,
      directionsService: {},
      directionsDisplay: {},
      myPolyline: null,
      rutas: [],
      place: null,
      autocomplete: 'Tenerife',
      google3: null,
      lat: null
    }
  },
  computed: {
    google2: VueGoogleMaps.gmapApi
  },
  methods: {
    getGeocode() {
      // "Calle La Rabasa,2. 38009. Santa Cruz de Tenerife"
      let url = 'https://maps.googleapis.com/maps/api/geocode/json';
      let params = {
        key: 'AIzaSyAal7_QwpdkdUQoIbxwPwyKNH2h6MMC1wk',
        address: this.direccion
      }

      // Via axios
      axios.get(url, { params })
        .then(function(response) {
            console.log(response.data);
            let result = response.data;
            this.result = result;
            
            if (result.status == 'OK') {
              console.log('resultado correcto')
              this.coordenadas = result.results[0].geometry.location;
              // Añade marcador
              this.markers.push({
                title: this.direccion,
                formatted_address: result.results[0].formatted_address,
                position: result.results[0].geometry.location
                });

              this.setBounds();
              
              // store.state.products = result.data;
            } else {
              this.coordenadas = null;
            }
        }.bind(this))
        .catch(function(error) {
            console.log(error)
        });

    },
    
    getGeocode2() {
      // Metodo 2
      let geocoder = new google.maps.Geocoder();
      // let geocoder = new this.google3.maps.Geocoder(); //Funciona tambien
      geocoder.geocode( {address: this.direccion}, (results, status) => {
        if (status === 'OK') {
          this.markers.push({
            title: this.direccion,
            formatted_address: results[0].formatted_address,
            position: results[0].geometry.location
          });
          this.setBounds();
        } else {
          console.log('Problemas con la peticion geocoder');
        }
      })
    },

    setBounds() {
      // reestablece limites del mapa
      let bounds = new google.maps.LatLngBounds();
      for (let i = 0; i < this.markers.length; i++) {
        bounds.extend(this.markers[i].position);
        console.log(this.markers[i].title)
      }
      this.$refs.mmm.fitBounds(bounds);
    },

    centrar(position) {
      this.center = position;
      console.log('Mapa centrado!')
    },

    log() {
      console.log("loggeando!")
    },

    clickMapa(e) {
      console.log(e.latLng.lat(), e.latLng.lng());
      console.log(e.latLng);
      this.getDistance(e.latLng);
    },

    getDistance(latLng) {
      let distanceService = new google.maps.DistanceMatrixService();
      let peticion = {
        origins: [this.central.position],
        destinations: [ latLng],
        travelMode: 'DRIVING'
      }
      distanceService.getDistanceMatrix(peticion, (response, status) => {
        console.log(response, status);
        console.log(response.rows[0].elements[0].distance)
      });

    },

    // Muestra la ruta pero no limpia la anterior visalizada.
    getRoute(latLng) {
      // https://developers.google.com/maps/documentation/javascript/directions
      let directionsService = new google.maps.DirectionsService();
      let directionsDisplay = new google.maps.DirectionsRenderer();
      
      directionsService.route({
        origin: this.myPosition,
        destination: latLng,
        travelMode: 'DRIVING'
      }, (response, status) => {
        if ( status === 'OK') {
          directionsDisplay.setMap(this.$refs.mmm.$mapObject);
          directionsDisplay.setDirections(response);
          console.log(this.$refs.mmm.$mapObject)
        } else {
          console.log('Peticion de ruta fallida');
        }

      })
    },

    // Funciona y no deja rastro de la ruta cuando cambia
    getRoute2(latLng) {
      // let vm = this;
      this.directionsService.route({
        origin: this.myPosition,
        destination: latLng,
        provideRouteAlternatives: true,
        travelMode: 'DRIVING'
      }, (response, status) => {
        if ( status === 'OK') {
          this.directionsDisplay.setMap(this.$refs.mmm.$mapObject);
          this.directionsDisplay.setPanel(document.getElementById('directions_panel'));
          this.directionsDisplay.setDirections(response);
          console.log(response);
          console.log('Distancia: ', response.routes[0].legs[0].distance);
          this.rutas = response.routes;
          this.distancia_ruta = response.routes[0].legs[0].distance.text;
        } else {
          console.log('Peticion de ruta fallida');
        }

      })
    },

    getDirections(latLng) {
      this.directionsService.route({
        origin: this.myPosition,
        destination: latLng,
        provideRouteAlternatives: true,
        travelMode: 'DRIVING'
      }, (response, status) => {
        if ( status === 'OK') {
          console.log(response);
          this.rutas = response;
        } else {
          console.log('Peticion de ruta fallida');
        }

      })
    },

    // Prueba para visualiza la ruta con Polyline
    showRoute(ruta) {
      console.log(ruta);
      if (this.myPolyline) {
        this.myPolyline.setMap(null);
      }
      this.myPolyline = new google.maps.Polyline({
        path: ruta.overview_path,
        strokeColor: "#ff0000",  // you might want different colors per suggestion
        strokeOpacity: 0.7,
        strokeWeight: 3
      });
      this.myPolyline.setMap(this.$refs.mmm.$mapObject);

      this.distancia_ruta = ruta.legs[0].distance.text;
    },

    

    // funcion geolocate con callback
    geolocate: function(callback) {
      navigator.geolocation.getCurrentPosition(position => {
        this.myPosition = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        callback();
      });
    },

    setPlace(place) {
      console.log(place);
      this.place = place;
    },

    usePlace(event) {
      if (this.place) {
        this.markers.push({
          title: this.place.formatted_address,
          formatted_address: this.place.formatted_address,
          position: this.place.geometry.location
        });
        console.log(this.place);
        console.log(JSON.stringify(this.place.geometry.location));
        this.place = null;
      }
    },

  },

  mounted() {
    // promise maps cargado
    this.$refs.mmm.$mapPromise.then((map) => {
      this.directionsService = new google.maps.DirectionsService();
      this.directionsDisplay = new google.maps.DirectionsRenderer();
      
      // prueba 
      this.google3 = new VueGoogleMaps.gmapApi;
      // console.log( new this.google3.maps.LatLng(1.38, 103.8));
      
      // limites del mapa con los markers
      this.setBounds();
    });
    
    // this.geolocate();
    this.geolocate( () => {
      this.center = this.myPosition;
      this.markers.push({
        title: "Mi posición",
        position: this.myPosition
      });
    });

    //this.markers.push(this.central);
    
  }
}
</script>

<style scoped>

</style>
